import PropTypes from 'prop-types';
import React from 'react';

require('./style.scss');

export default class Popover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  render() {
    return (
      <span className="popover">
        <span
          className="popover-anchor"
          onClick={() => this.setState({ open: !this.state.open })}
        >
          {this.props.anchor}
        </span>

        {this.state.open ?
          <div className="popover-content">{this.props.children}</div> :
          null}
      </span>
    );
  }
}

Popover.propTypes = {
  anchor: PropTypes.node,
  children: PropTypes.node,
};

module.exports = Popover;



// WEBPACK FOOTER //
// ./app/components/common/popover/Popover.jsx